import {
  Bold,
  Center,
  Indent,
  Italic,
  Left,
  Ol,
  Outdent,
  Right,
  Strike,
  Ul,
  Underline,
} from "../../layouts/icons";

function ToolbarElements() {
  const toolbarBtns = [
    { action: "bold", title: <Bold /> },
    { action: "italic", title: <Italic /> },
    { action: "underline", title: <Underline /> },
    { action: "strikeThrough", title: <Strike /> },
    { action: "justifyLeft", title: <Left /> },
    { action: "justifyRight", title: <Right /> },
    { action: "justifyCenter", title: <Center /> },
    { action: "insertOrderedList", title: <Ol /> },
    { action: "insertUnorderedList", title: <Ul /> },
    { action: "outdent", title: <Outdent /> },
    { action: "indent", title: <Indent /> },
  ];

  const toolbarFontSizes = [
    { value: "1", title: "Very Small" },
    { value: "2", title: "Small" },
    { value: "3", title: "Normal" },
    { value: "4", title: "Medium" },
    { value: "5", title: "Large" },
    { value: "6", title: "Extra Large" },
    { value: "7", title: "2XL" },
  ];

  const toolbarHeadings = [
    { value: "P", title: "Normal" },
    { value: "H1", title: "H1" },
    { value: "H2", title: "H2" },
    { value: "H3", title: "H3" },
    { value: "BLOCKQUOTE", title: "Blockquote" },
  ];

  const toolbarColors = [
    { title: "Text Color", action: "foreColor", type: "color" },
    { title: "Highlight", action: "hiliteColor", type: "color" },
  ];

  return { toolbarBtns, toolbarColors, toolbarFontSizes, toolbarHeadings };
}

export default ToolbarElements;
